import script from "./AdminPrayerMeetings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPrayerMeetings.vue?vue&type=script&setup=true&lang=js"

import "./AdminPrayerMeetings.vue?vue&type=style&index=0&id=e04bab4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e04bab4c"]])

export default __exports__